module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isMobile) ? _c('el-dialog', {
    staticClass: "agent-chat-dialog",
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('agent-chat', {
    attrs: {
      "is-mobile": true,
      "policy-number": _vm.policyNumber,
      "claim-number": _vm.claimNumber,
      "claim-id": _vm.claimId
    },
    on: {
      "on-close": _vm.onClose
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar"
    }
  }, [(!_vm.isMobile && _vm.visible) ? _c('aside', {
    staticClass: "agent-chat-aside"
  }, [_c('div', {
    staticClass: "agent-chat-aside__inner"
  }, [_c('agent-chat', {
    attrs: {
      "is-mobile": false,
      "policy-number": _vm.policyNumber,
      "claim-number": _vm.claimNumber,
      "claim-id": _vm.claimId
    },
    on: {
      "on-close": _vm.onClose
    }
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}